import React from "react";
import { TableCell } from "@mui/material";

const headerCellSx = {
  p: 5,
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "0.17px",
  color: "text.primary",
};

export const tableHeaders = [
  <TableCell key="start-time" sx={headerCellSx}>
    Start Time
  </TableCell>,
  <TableCell key="end-time" sx={headerCellSx}>
    End Time
  </TableCell>,
  <TableCell key="duration" sx={headerCellSx}>
    Duration
  </TableCell>,
  <TableCell key="service" sx={headerCellSx}>
    Service
  </TableCell>,
  <TableCell key="details" sx={headerCellSx}>
    Details
  </TableCell>,
  <TableCell key="actions" sx={headerCellSx}>
    Actions
  </TableCell>,
];
